export { withDeferredWrmLoaded } from './with-deferred-wrm-loaded';
export { default as DeferredWrmResourceProvider } from './wrm-resource-provider';
